import type { ReactNode } from 'react'

export function MetricCard({
  label,
  value,
  helper,
  icon,
  emphasis = false,
}: {
  label: string
  value: ReactNode
  helper: string
  icon?: ReactNode
  emphasis?: boolean
}) {
  return (
    <article className={`metric-card ${emphasis ? 'metric-card--emphasis' : ''}`}>
      <div className="metric-card__top">
        <span>{label}</span>
        {icon && <i>{icon}</i>}
      </div>
      <strong>{value}</strong>
      <small>{helper}</small>
    </article>
  )
}
